import { getMessages } from '../../../../../../../../store/constants';

export const CARD_ASSIGNEES_TOOLTIP = getMessages().getText('card_form_assignee_add');
